import React from 'react';
import styled from 'styled-components';
import {Text} from '../../atoms/Text/Text';
import {SliderControlProps} from '../../molecules/HorizontalSlider/types';
import {
  SliderPaginationBase,
  SliderPaginationBaseProps,
} from './SliderPaginationBase';

export const SliderPagination: React.FC<
  SliderPaginationBaseProps &
    Pick<SliderControlProps, 'currentSlide' | 'maxPages'>
> = ({currentSlide, maxPages, ...rest}) => {
  return (
    <SliderPaginationBase {...rest}>
      <Page size="px10" color="Grey0" textAlignment="center">
        {currentSlide + 1} / {maxPages}
      </Page>
    </SliderPaginationBase>
  );
};

const Page = styled(Text)`
  flex: 1;
  letter-spacing: 3px;
`;
